/**
 * Software Capabilities Section — software-capabilities.js
 *
 * Animation: pure CSS `grid-template-rows` transition (0fr ↔ 1fr).
 * The CSS sets `display: grid !important` on .sfc-faq-answer which
 * overrides the browser UA `display: none` applied to <details> content
 * when [open] is absent. This means toggling [open] is enough to trigger
 * the smooth CSS transition in both directions — no JS timers needed.
 *
 * Double-init guard: the <script> tag is inside the section Liquid file
 * so it runs once per section instance on the page. The `data-sfc-init`
 * flag ensures each <details> element only ever gets one click listener.
 */
(function () {
  'use strict';

  function closeSiblings(currentDetails) {
    var faq = currentDetails.closest('.sfc-faq');
    if (!faq) return;
    faq.querySelectorAll('.sfc-faq-item[open]').forEach(function (sibling) {
      if (sibling !== currentDetails) sibling.removeAttribute('open');
    });
  }

  function initFaqItem(details) {
    if (details.dataset.sfcInit === 'true') return;
    details.dataset.sfcInit = 'true';

    var summary = details.querySelector('.sfc-faq-question');
    if (!summary) return;

    summary.addEventListener('click', function (e) {
      e.preventDefault();

      if (details.hasAttribute('open')) {
        details.removeAttribute('open');
      } else {
        closeSiblings(details);
        details.setAttribute('open', '');
      }
    });
  }

  function init() {
    document.querySelectorAll('.sfc-faq-item').forEach(initFaqItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
